import { HubRoute } from '@/types/hub'
import { SuggestionOption, SuggestionType } from '@/types/reader'

export const filterSuggestedOptions = (options: SuggestionOption[], query: string): SuggestionOption[] => {
    const startsWithQuery = (str: string) => str.toLowerCase().includes(query.toLowerCase())
    const routeMatchesQuery = (routes: HubRoute[]) => routes.some((r) => startsWithQuery(r.route))

    const routeItems: SuggestionOption[] = []
    const workstationNameMatches: SuggestionOption[] = []
    const workstationRouteMatches: SuggestionOption[] = []
    const garageItems: SuggestionOption[] = []
    const areaItems: SuggestionOption[] = []

    for (const option of options) {
        const { title, type, routes } = option

        switch (type) {
            case SuggestionType.Route: {
                startsWithQuery(title) && routeItems.push(option)
                break
            }
            case SuggestionType.Workstation: {
                if (startsWithQuery(title)) {
                    workstationNameMatches.push(option)
                } else if (routeMatchesQuery(routes)) {
                    workstationRouteMatches.push(option)
                }
                break
            }
            case SuggestionType.Garage: {
                startsWithQuery(title) && garageItems.push(option)
                break
            }
            case SuggestionType.Area: {
                startsWithQuery(title) && areaItems.push(option)
                break
            }
            default: {
                break
            }
        }
    }

    const sortByTitle = (a: SuggestionOption, b: SuggestionOption) =>
        a.title.localeCompare(b.title, undefined, { numeric: true })

    return [
        ...routeItems.sort(sortByTitle),
        ...workstationNameMatches.sort(sortByTitle),
        ...workstationRouteMatches.sort(sortByTitle),
        ...garageItems.sort(sortByTitle),
        ...areaItems.sort(sortByTitle),
    ]
}
